module.exports = __webpack_public_path__ + "static/media/cranes_zim_2.6eedaf35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/botswana/cranes_zim_2.jpg
// module id = 292
// module chunks = 0